import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: 'report',
		loadChildren: () => import('./features/report/report.module').then(m => m.ReportModule),
	},
	{
		path: '',
		loadChildren: () => import('./features/arc/arc.module').then(m => m.ArcModule),
	}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
